import React from "react";
import { Reveal, RevealGroup, RevealItem } from "@/components/site/Reveal";
import { VideoFacade } from "@/components/site/VideoFacade";

export const Watch = ({ videos = [] }) => {
  if (!videos || videos.length === 0) return null;
  const featured = videos.find((v) => v.featured) || videos[0];
  const rest = videos.filter((v) => v.id !== featured.id);
  return (
    <section id="watch" className="section-pad" data-testid="watch-section">
      <div className="mx-auto max-w-[1360px] px-5 sm:px-8">
        <Reveal>
          <p className="font-caps text-gold" style={{ fontSize: ".72rem" }}>Watch</p>
          <h2 className="font-display foil-text mt-3" style={{ fontSize: "var(--t-h2)", lineHeight: 1.05 }}>Music videos and previews</h2>
        </Reveal>
        <Reveal delay={0.05} className="mt-12"><VideoFacade video={featured} big /></Reveal>
        {rest.length > 0 && (
          <RevealGroup className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8" stagger={0.05}>
            {rest.map((v) => <RevealItem key={v.id}><VideoFacade video={v} /></RevealItem>)}
          </RevealGroup>
        )}
      </div>
    </section>
  );
};
